/**
 * The person's email notifications, kept by the sandbox gateway (`GET/PUT /api/v1/me/notifications`): whether they want
 * an email when someone shares a project with them, and in which language. `available` tells whether their organization
 * has sharing emails switched on (and a mail server configured); the choice is saved either way.
 */
import config from '../config';
import { getAuthorizedFetch } from '../utils/fetchRegistry';
import { buildAclContextHeaders } from '../utils/aclContext';

const url = () => `${config.vfsServiceUrl.replace(/\/$/, '')}/api/v1/me/notifications`;

/** `{ shareEmails, locale, available }`, or `null` when vfs-service is not configured or does not know them (older backend). */
export async function getNotificationSettings() {
  if (!config.vfsServiceUrl) { return null; }
  const response = await getAuthorizedFetch()(url(), { headers: { Accept: 'application/json', ...buildAclContextHeaders() } });
  if (response.status === 404) { return null; }
  if (!response.ok) { throw new Error(`Notification settings failed (${response.status})`); }
  return response.json();
}

/** Saves `{ shareEmails?, locale? }` and resolves to all the notification settings. */
export async function updateNotificationSettings(partial) {
  if (!config.vfsServiceUrl) { return null; }
  const response = await getAuthorizedFetch()(url(), {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json', ...buildAclContextHeaders() },
    body: JSON.stringify(partial),
  });
  if (!response.ok) { throw new Error(`Saving notification settings failed (${response.status})`); }
  return response.json();
}

/** The language emails are sent in: Italian when the browser is in Italian, English otherwise. */
export function browserEmailLocale() {
  const language = typeof navigator !== 'undefined' ? navigator.language || '' : '';
  return language.toLowerCase().startsWith('it') ? 'it' : 'en';
}
